module.exports = __webpack_public_path__ + "static/images/questionMark.e32de9bbeafefaa6642482fd013552e8.svg";